/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Tab_Home_Extra1Inputs */

const vi_sitesettings_tab_home_extra1 = /** @type {(inputs: Sitesettings_Tab_Home_Extra1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang chủ (chữ phụ)`)
};

/**

* @param {Sitesettings_Tab_Home_Extra1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_tab_home_extra1 = /** @type {((inputs?: Sitesettings_Tab_Home_Extra1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Tab_Home_Extra1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_tab_home_extra1(inputs)
});
export { sitesettings_tab_home_extra1 as "siteSettings_tab_home_extra" }